export const NOTIFICATIONS_POLLING = "NOTIFICATIONS_POLLING";
export const JWT_REFRESH = "JWT_REFRESH";
